import { xsollaStore } from '../xsollaStore';
import { accessTokenCService } from 'api/accessToken/accessTokenCService';
import { httpApi } from 'core/httpApi';

export const setToken = (token: string | undefined) => {
    httpApi.setToken(token);
    xsollaStore.setToken(token);
    accessTokenCService.set(token);
};
